export const onedioEvents = () => {
  // push event
  const pushEvent = (params) => {
    window.dataLayer.push(params);
  };

  /// generic event sender
  const sendEvent = (eventType, category, action, label, additionalParams = {}) => {
    pushEvent({
      event: 'onedio_events',
      event_type: eventType,
      event_category: category,
      event_action: action,
      event_label: label,
      ...additionalParams,
    });
  };

  // specific event functions
  const sendAuthEvent = (category, action, label) => {
    sendEvent('user_actions', category, action, label);
  };

  const sendGameEvent = (category, action, label, gameName) => {
    sendEvent('game_interactions', category, action, label, { game_name: gameName });
  };

  const sendVitrinEvent = (category, action, label, contentId) => {
    sendEvent('vitrin_click', category, action, label, { content_id: contentId });
  };

  const sendAdEvent = (category, action, label) => {
    sendEvent('ad_interactions', category, action, label);
  };

  const sendKesfetEvent = (category, action, label) => {
    sendEvent('kesfet_interactions', category, action, label);
  };

  const sendHomepageEvent = (category, action, label, tag) => {
    sendEvent('homepage', category, action, label, tag && { event_tag: tag });
  };

  const sendDetayInteractionEvent = (category, action, label) => {
    sendEvent('detay_interactions', category, action, label);
  };

  const sendDetaySidebarEvent = (category, action, label) => {
    sendEvent('detay_arakartlar', category, action, label);
  };

  const sendSearchEvent = (category, action, label) => {
    sendEvent('search_interaction', category, action, label);
  };

  const sendMenuEvent = (category, action, label) => {
    sendEvent('menu_interaction', category, action, label);
  };

  const sendMessageEvent = (category, action, label) => {
    sendEvent('message_interaction', category, action, label);
  };

  const sendProfileEvent = (category, action, label) => {
    sendEvent('profil_interaction', category, action, label);
  };

  return {
    sendAuthEvent,
    sendGameEvent,
    sendVitrinEvent,
    sendAdEvent,
    sendKesfetEvent,
    sendHomepageEvent,
    sendDetayInteractionEvent,
    sendDetaySidebarEvent,
    sendSearchEvent,
    sendMenuEvent,
    sendMessageEvent,
    sendProfileEvent,
  };
};
